// SS-1 — minimal EXIF reader: DateTimeOriginal (0x9003) from a JPEG, for imported gallery photos. Returns epoch ms or null.
export async function exifTakenAt(file) {
  try {
    const buf = new DataView(await file.slice(0, 256 * 1024).arrayBuffer());
    if (buf.getUint16(0) !== 0xffd8) return null;
    let off = 2;
    while (off + 4 < buf.byteLength) {
      const marker = buf.getUint16(off), len = buf.getUint16(off + 2);
      if (marker === 0xffe1 && buf.getUint32(off + 4) === 0x45786966) { // "Exif"
        const t = off + 10, le = buf.getUint16(t) === 0x4949;
        const u16 = (p) => buf.getUint16(p, le), u32 = (p) => buf.getUint32(p, le);
        const ifd0 = t + u32(t + 4); const n0 = u16(ifd0); let exifIfd = 0;
        for (let i = 0; i < n0; i++) { const e = ifd0 + 2 + i * 12; if (u16(e) === 0x8769) exifIfd = t + u32(e + 8); }
        if (!exifIfd) return null;
        const n1 = u16(exifIfd);
        for (let i = 0; i < n1; i++) {
          const e = exifIfd + 2 + i * 12;
          if (u16(e) === 0x9003) { const p = t + u32(e + 8); let s = ''; for (let k = 0; k < 19; k++) s += String.fromCharCode(buf.getUint8(p + k)); const m = s.match(/^(\d{4}):(\d{2}):(\d{2}) (\d{2}):(\d{2}):(\d{2})$/); return m ? new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +m[6]).getTime() : null; }
        }
        return null;
      }
      if ((marker & 0xff00) !== 0xff00) return null;
      off += 2 + len;
    }
  } catch { /* unreadable */ }
  return null;
}
